"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultProtoCodec = exports.ProtoCodec = void 0;
const msgs_1 = require("@keplr-wallet/proto-types/agoric/swingset/msgs");
const tx_1 = require("@keplr-wallet/proto-types/cosmos/bank/v1beta1/tx");
const tx_2 = require("@keplr-wallet/proto-types/cosmos/staking/v1beta1/tx");
const tx_3 = require("@keplr-wallet/proto-types/cosmos/authz/v1beta1/tx");
const tx_4 = require("@keplr-wallet/proto-types/cosmos/gov/v1beta1/tx");
const tx_5 = require("@keplr-wallet/proto-types/cosmos/distribution/v1beta1/tx");
const tx_6 = require("@keplr-wallet/proto-types/cosmwasm/wasm/v1/tx");
const tx_7 = require("@keplr-wallet/proto-types/ibc/applications/transfer/v1/tx");
const tx_8 = require("@keplr-wallet/proto-types/ibc/applications/fee/v1/tx");
const unknown_1 = require("./unknown");
const authz_1 = require("@keplr-wallet/proto-types/cosmos/authz/v1beta1/authz");
const authz_2 = require("@keplr-wallet/proto-types/cosmos/staking/v1beta1/authz");
const authz_3 = require("@keplr-wallet/proto-types/cosmos/bank/v1beta1/authz");
const tx_9 = require("@keplr-wallet/proto-types/stride/stakeibc/tx");
const tx_10 = require("@keplr-wallet/proto-types/stride/staketia/tx");
const tx_11 = require("@keplr-wallet/proto-types/stride/stakedym/tx");
const buffer_1 = require("buffer/");
__exportStar(require("./unknown"), exports);
class ProtoCodec {
    constructor() {
        this.typeUrlMap = new Map();
    }
    unpackAnyFactory(typeUrl) {
        if (!this.typeUrlMap.has(typeUrl)) {
            return undefined;
        }
        return this.typeUrlMap.get(typeUrl);
    }
    /**
     * Unpack the any to the registered message.
     * NOTE: If there is no matched message, it will not throw an error but return the `UnknownMessage` class.
     * @param any
     */
    unpackAny(any) {
        const factory = this.unpackAnyFactory(any.typeUrl);
        if (!factory) {
            return new unknown_1.UnknownMessage(any.typeUrl, any.value);
        }
        const unpacked = factory.decode(any.value);
        return Object.assign(Object.assign({}, any), { unpacked });
    }
    unpackedAnyToJSONRecursive(unpacked) {
        if (unpacked instanceof unknown_1.UnknownMessage) {
            return unpacked.toJSON();
        }
        const factory = this.unpackAnyFactory(unpacked.typeUrl);
        if (factory && "unpacked" in unpacked && unpacked.unpacked) {
            const isJSONEncodedAny = (any) => {
                const r = typeof any === "object" &&
                    !(any instanceof unknown_1.UnknownMessage) &&
                    "typeUrl" in any &&
                    any.typeUrl &&
                    typeof any.typeUrl === "string" &&
                    "value" in any &&
                    any.value &&
                    typeof any.value === "string";
                if (r) {
                    try {
                        buffer_1.Buffer.from(any.value, "base64");
                    }
                    catch (_a) {
                        return false;
                    }
                }
                return r;
            };
            const unpackJSONEncodedAnyInner = (jsonEncodedAny) => {
                const factory = this.unpackAnyFactory(jsonEncodedAny.typeUrl);
                const bz = buffer_1.Buffer.from(jsonEncodedAny.value, "base64");
                if (!factory) {
                    return new unknown_1.UnknownMessage(jsonEncodedAny.typeUrl, bz).toJSON();
                }
                const unpacked = factory.decode(bz);
                return {
                    typeUrl: jsonEncodedAny.typeUrl,
                    value: factory.toJSON(unpacked),
                };
            };
            const unpackedJSONEncodedAnyRecursive = (obj) => {
                if (Array.isArray(obj)) {
                    for (let i = 0; i < obj.length; i++) {
                        const value = obj[i];
                        if (isJSONEncodedAny(value)) {
                            obj[i] = unpackJSONEncodedAnyInner(value);
                        }
                        else if (typeof value === "object") {
                            obj[i] = unpackedJSONEncodedAnyRecursive(value);
                        }
                    }
                }
                else {
                    for (const key in obj) {
                        const value = obj[key];
                        if (isJSONEncodedAny(value)) {
                            obj[key] = unpackJSONEncodedAnyInner(value);
                        }
                        else if (typeof value === "object") {
                            obj[key] = unpackedJSONEncodedAnyRecursive(value);
                        }
                    }
                }
                return obj;
            };
            // This is mutated by logic.
            let mutObj = factory.toJSON(unpacked.unpacked);
            if (mutObj && typeof mutObj === "object") {
                mutObj = unpackedJSONEncodedAnyRecursive(mutObj);
                return {
                    typeUrl: unpacked.typeUrl,
                    value: mutObj,
                };
            }
        }
        return new unknown_1.UnknownMessage(unpacked.typeUrl, unpacked.value).toJSON();
    }
    registerAny(typeUrl, message) {
        this.typeUrlMap.set(typeUrl, message);
    }
}
exports.ProtoCodec = ProtoCodec;
exports.defaultProtoCodec = new ProtoCodec();
exports.defaultProtoCodec.registerAny("/agoric.swingset.MsgWalletSpendAction", msgs_1.MsgWalletSpendAction);
exports.defaultProtoCodec.registerAny("/agoric.swingset.MsgProvision", msgs_1.MsgProvision);
exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.MsgSend", tx_1.MsgSend);
exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.MsgMultiSend", tx_1.MsgMultiSend);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgDelegate", tx_2.MsgDelegate);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgUndelegate", tx_2.MsgUndelegate);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgBeginRedelegate", tx_2.MsgBeginRedelegate);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgUnbondValidator", tx_2.MsgUnbondValidator);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgCancelUnbondingDelegation", tx_2.MsgCancelUnbondingDelegation);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgTokenizeShares", tx_2.MsgTokenizeShares);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgRedeemTokensForShares", tx_2.MsgRedeemTokensForShares);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgTransferTokenizeShareRecord", tx_2.MsgTransferTokenizeShareRecord);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgDisableTokenizeShares", tx_2.MsgDisableTokenizeShares);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgEnableTokenizeShares", tx_2.MsgEnableTokenizeShares);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgValidatorBond", tx_2.MsgValidatorBond);
exports.defaultProtoCodec.registerAny("/cosmwasm.wasm.v1.MsgExecuteContract", tx_6.MsgExecuteContract);
exports.defaultProtoCodec.registerAny("/cosmwasm.wasm.v1.MsgInstantiateContract", tx_6.MsgInstantiateContract);
exports.defaultProtoCodec.registerAny("/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", tx_5.MsgWithdrawDelegatorReward);
exports.defaultProtoCodec.registerAny("/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", tx_5.MsgSetWithdrawAddress);
exports.defaultProtoCodec.registerAny("/ibc.applications.transfer.v1.MsgTransfer", tx_7.MsgTransfer);
exports.defaultProtoCodec.registerAny("/ibc.applications.fee.v1.MsgPayPacketFee", tx_8.MsgPayPacketFee);
exports.defaultProtoCodec.registerAny("/ibc.applications.fee.v1.MsgPayPacketFeeAsync", tx_8.MsgPayPacketFeeAsync);
exports.defaultProtoCodec.registerAny("/ibc.applications.fee.v1.MsgRegisterPayee", tx_8.MsgRegisterPayee);
exports.defaultProtoCodec.registerAny("/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee", tx_8.MsgRegisterCounterpartyPayee);
exports.defaultProtoCodec.registerAny("/cosmos.gov.v1beta1.MsgVote", tx_4.MsgVote);
exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.MsgGrant", tx_3.MsgGrant);
// ----- Authz grants -----
exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.GenericAuthorization", authz_1.GenericAuthorization);
exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.StakeAuthorization", authz_2.StakeAuthorization);
exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.SendAuthorization", authz_3.SendAuthorization);
// ----- Authz grants -----
exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.MsgRevoke", tx_3.MsgRevoke);
exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.MsgExec", tx_3.MsgExec);
// Stride
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgLiquidStake", tx_9.MsgLiquidStake);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgLSMLiquidStake", tx_9.MsgLSMLiquidStake);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgRedeemStake", tx_9.MsgRedeemStake);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgRegisterHostZone", tx_9.MsgRegisterHostZone);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgClaimUndelegatedTokens", tx_9.MsgClaimUndelegatedTokens);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgRebalanceValidators", tx_9.MsgRebalanceValidators);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgAddValidators", tx_9.MsgAddValidators);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgChangeValidatorWeight", tx_9.MsgChangeValidatorWeight);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgDeleteValidator", tx_9.MsgDeleteValidator);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgRestoreInterchainAccount", tx_9.MsgRestoreInterchainAccount);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgUpdateValidatorSharesExchRate", tx_9.MsgUpdateValidatorSharesExchRate);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgCalibrateDelegation", tx_9.MsgCalibrateDelegation);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgClearBalance", tx_9.MsgClearBalance);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgUndelegateHost", tx_9.MsgUndelegateHost);
exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgUpdateInnerRedemptionRateBounds", tx_9.MsgUpdateInnerRedemptionRateBounds);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgLiquidStake", tx_10.MsgLiquidStake);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgRedeemStake", tx_10.MsgRedeemStake);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgConfirmDelegation", tx_10.MsgConfirmDelegation);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgConfirmUndelegation", tx_10.MsgConfirmUndelegation);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgConfirmUnbondedTokenSweep", tx_10.MsgConfirmUnbondedTokenSweep);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgAdjustDelegatedBalance", tx_10.MsgAdjustDelegatedBalance);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgUpdateInnerRedemptionRateBounds", tx_10.MsgUpdateInnerRedemptionRateBounds);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgResumeHostZone", tx_10.MsgResumeHostZone);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgRefreshRedemptionRate", tx_10.MsgRefreshRedemptionRate);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgOverwriteDelegationRecord", tx_10.MsgOverwriteDelegationRecord);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgOverwriteUnbondingRecord", tx_10.MsgOverwriteUnbondingRecord);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgOverwriteRedemptionRecord", tx_10.MsgOverwriteRedemptionRecord);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgOverwriteRedemptionRecord", tx_10.MsgOverwriteRedemptionRecord);
exports.defaultProtoCodec.registerAny("/stride.staketia.MsgSetOperatorAddress", tx_10.MsgSetOperatorAddress);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgLiquidStake", tx_11.MsgLiquidStake);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgRedeemStake", tx_11.MsgRedeemStake);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgConfirmDelegation", tx_11.MsgConfirmDelegation);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgConfirmUndelegation", tx_11.MsgConfirmUndelegation);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgConfirmUnbondedTokenSweep", tx_11.MsgConfirmUnbondedTokenSweep);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgAdjustDelegatedBalance", tx_11.MsgAdjustDelegatedBalance);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgUpdateInnerRedemptionRateBounds", tx_11.MsgUpdateInnerRedemptionRateBounds);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgResumeHostZone", tx_11.MsgResumeHostZone);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgRefreshRedemptionRate", tx_11.MsgRefreshRedemptionRate);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgOverwriteDelegationRecord", tx_11.MsgOverwriteDelegationRecord);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgOverwriteUnbondingRecord", tx_11.MsgOverwriteUnbondingRecord);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgOverwriteRedemptionRecord", tx_11.MsgOverwriteRedemptionRecord);
exports.defaultProtoCodec.registerAny("/stride.stakedym.MsgSetOperatorAddress", tx_11.MsgSetOperatorAddress);
//# sourceMappingURL=index.js.map